import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Stack, Typography, TextField, Checkbox } from '@mui/material';
import { SmallFormTextField } from '../../../../../../components-core/small-fields/SmallFormTextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateTimePicker from '@mui/lab/DateTimePicker';
import { formatDateTime } from '../../../../../../services/functions';

const OrderDetailsForm = ({ formik }) => {
  const { order } = useSelector(state => state.app);

  return (
    <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1}>
      <Stack justifyContent="space-around" spacing={1} sx={{ width: '100%' }}>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Numer Zamówienia</Typography>
          <SmallFormTextField
            error={formik.errors.identifier && formik.touched.identifier}
            name="identifier"
            placeholder="numer zamówienia"
            value={formik.values.identifier}
            onChange={formik.handleChange}
            helperText={formik.errors.identifier}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Data zamówienia</Typography>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              name="created_at"
              inputFormat="yyyy-MM-dd HH:mm"
              mask="____-__-__ __:__"
              label="data zamówienia"
              value={formik.values.created_at}
              ampm={false}
              onChange={val => formik.setFieldValue('created_at', formatDateTime(val))}
              renderInput={params => <TextField size="small" sx={{ width: '60%' }} {...params} />}
            />
          </LocalizationProvider>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Ośrodek</Typography>
          <SmallFormTextField
            select
            name="resort"
            placeholder="ośrodek"
            options={order.resort_event_data.resorts}
            value={formik.values.resort}
            onChange={formik.handleChange}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Zajęcia</Typography>
          <SmallFormTextField
            select
            name="event"
            placeholder="zajęcia"
            options={order.resort_event_data.events[formik.values.resort]}
            value={formik.values.event}
            onChange={formik.handleChange}
            whiteSpaceNormal={true}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Rabat</Typography>
          <SmallFormTextField
            id="discount_amount"
            value={formik.values.discount_amount}
            label="Rabat uczestnika"
            // variant="outlined"
            type="number"
            onChange={formik.handleChange}
            error={formik.errors.discount_amount && formik.touched.discount_amount}
            helperText={formik.errors.discount_amount}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Kwota potrąceń na przyszły miesiąc</Typography>
          <SmallFormTextField
            id="deduction_amount"
            value={formik.values.deduction_amount}
            label="Kwota potrąceń na przyszły miesiąc"
            // variant="outlined"
            type="number"
            onChange={formik.handleChange}
            error={formik.errors.deduction_amount && formik.touched.deduction_amount}
            helperText={formik.errors.deduction_amount}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 25%">
          <Checkbox id="generate_monthly_payment" name="generate_monthly_payment" checked={formik.values.generate_monthly_payment} onChange={formik.handleChange}/>
          <Typography variant="subtitle2">Generuj opłatę miesięczną</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Uwagi</Typography>
          <SmallFormTextField name="comments" placeholder="uwagi" multiline rows={8} value={formik.values.comments} onChange={formik.handleChange} />
        </Stack>
      </Stack>
    </Box>
  );
};

export default OrderDetailsForm;
